import { z } from 'zod';

export const candidateStatusMessageMaxLength = 500;

export const TalentWarmingModalSchema = z.object({
  candidateStatusMessage: z.string().max(candidateStatusMessageMaxLength),
});

export type TalentWarmingModal = z.infer<typeof TalentWarmingModalSchema>;
